import type { Translations } from '../types';

export const en: Translations = {
  // Header
  signIn: 'Sign In',
  getStarted: 'Get Started',

  // Hero
  heroTitle1: 'Find your people.',
  heroTitle2: 'Anywhere.',
  heroDescription:
    'Discover authentic businesses, reserve offerings from community providers, and connect with people you trust — anywhere in the world.',
  detected: 'Detected:',
  detectingLocation: 'Detecting location…',
  locationUnavailable: 'Location unavailable',
  joinCommunity: 'Join Your Community',
  learnMore: 'Learn More',

  // Community Selection
  selectCommunity: 'Select your community',
  selectCommunityDesc: 'Join the community that feels like home',
  exploreMore: 'Explore More Communities',

  // Status Badges
  active: 'Active',
  incubating: 'Incubating',

  // Community Names (localizable)
  everywhereElse: 'Everywhere Else',

  // Features
  howConnect: 'How do you connect?',
  howConnectDesc:
    'Quul helps you discover, reserve, and share what matters in your community.',
  discover: 'Discover',
  discoverDesc:
    'Find authentic businesses, services, and events recommended by people you trust.',
  review: 'Review',
  reviewDesc:
    'Share your experiences with multi-dimensional ratings and detailed reviews.',
  connect: 'Connect',
  connectDesc:
    'Chat with community members, business owners, and service providers.',
  marketplace: 'Reserve',
  marketplaceDesc:
    'Reserve offerings from community providers. Secure Stripe payments, with clear cancellation and refund policies.',

  // CTA
  ctaTitle: 'Ready to join your community?',
  ctaDesc: 'Sign up now and discover what your community has been sharing.',
  getStartedFree: 'Get Started Free',

  // Footer
  terms: 'Terms',
  privacy: 'Privacy',
  childSafety: 'Child Safety',
  reportNotice: 'Report or notice of infringement',
  contact: 'Contact',
  mayilabsLine: 'Quul is a product of MayiLabs LLC · Shakopee, Minnesota, USA',

  // App Store
  comingSoon: 'Coming Soon',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  getOnGooglePlay: 'Get it on',
  getOnAppStore: 'Download on the',
  comingToAppStore: 'Coming soon to',
  manos: {
    ribbonText: 'Before opening our marketplace, we opened a Crisis Center for Venezuela.',
    ribbonCta: 'View',
    ribbonDismiss: 'Dismiss notice',
    navItem: 'Venezuela',
    bandHeadline: 'Crisis Center — Venezuela',
    bandSubtext: 'Verified organizations, official channels to locate family, and trustworthy information.',
    ctaHelp: 'How to help',
    ctaFindOffer: 'Find or offer help',
    ctaLocate: 'Locate a family member',
    modalTitle: 'Before opening our marketplace, we opened a Crisis Center',
    modalBody: 'We gathered verified organizations, official channels to locate family, and trustworthy information for the emergency in Venezuela.',
    modalPrimary: 'Go to the Crisis Center',
    modalDismiss: 'Not now',
    modalClose: 'Close',
  },
};
